import { WorkspaceRoleEnum } from '@schemas/workspace'

import { ApiRequestError, api, type SessionResponse } from '../api.ts'

const SIGNED_OUT_SESSION: SessionResponse = {
  connected: false,
  accountId: null,
  displayName: null,
  setupComplete: false,
  setupStep: null,
  accounts: [],
  degradedSince: null,
  missingScopes: [],
  handoffShownAt: null,
  nextRunAt: null,
  activeCampaign: null,
  // No real workspace to name while signed out. Admin so the shell's admin layout stays the
  // default here too (same reasoning as canManage's null-session branch).
  activeWorkspace: { id: '', name: '', role: WorkspaceRoleEnum.enum.admin, isTeam: false, accountCount: 0 },
  workspaces: []
}

// The session the root loader last resolved. A child loader runs *before* its element renders,
// so a member navigating to an admin-only surface fires that surface's whole fetch fan-out and
// then throws the result away when AdminOnly paints the refusal instead (RAL-121 part 1
// carry-over). React Router gives a child loader no access to its parent's data, and this is the
// only session read in the app, so the loader records it here for the children that need it.
let lastSession: SessionResponse | null = null

export const lastLoadedSession = (): SessionResponse | null => lastSession

export async function loader(): Promise<SessionResponse> {
  try {
    lastSession = await api.get<SessionResponse>('/api/session')
    return lastSession
  } catch (err) {
    // The root loader runs before <SignedIn>/<SignedOut> below get a chance to gate
    // rendering, so a signed-out visitor hits this before Clerk has attached a token.
    // Treat 401 as "not connected" instead of blowing up the whole route tree.
    if (err instanceof ApiRequestError && err.status === 401) {
      lastSession = SIGNED_OUT_SESSION
      return SIGNED_OUT_SESSION
    }
    throw err
  }
}
